import {
  ACCOUNT_TYPE_ADMIN,
  ACCOUNT_TYPE_AGENT,
  ACCOUNT_TYPE_OWNER,
  PAGE_STATUS_DRAFT,
  PAGE_STATUS_PENDING,
  PAGE_STATUS_APPROVED,
  PAGE_STATUS_REJECTED,
} from './index';

export default {
  accountType: {
    [ACCOUNT_TYPE_ADMIN]: 'Super',
    [ACCOUNT_TYPE_AGENT]: 'Agent',
    [ACCOUNT_TYPE_OWNER]: 'Supplier',
  },
  pageStatus: {
    [PAGE_STATUS_DRAFT]: 'Draft',
    [PAGE_STATUS_PENDING]: 'Pending',
    [PAGE_STATUS_APPROVED]: 'Published',
    [PAGE_STATUS_REJECTED]: 'Rejected',
  },
  plan: {
    unpaid: 'Unpaid',
    paid: 'Paid',
    trial: 'Free Trial',
    tier_1: 'Tier I',
    tier_2: 'Tier II',
    tier_custom: 'Tier III',
    payment_pending: 'Payment Pending',
  },
};
